import { RootState } from '../store';

export const getHasPremiumArticleEloquaForm = (state: RootState) =>
  state.articles.hasPremiumArticleEloquaForm;
export const getFilters = (state: RootState) => state.articles.filters;
export const getArticlesData = (state: RootState) => state.articles;
